import { Injectable } from '@angular/core';

import { ConfirmationModalOptions } from './confirmation-modal.interfaces';
import {
  ConfirmationModalComponent,
  ConfirmationModalResult,
} from './confirmation-modal.component';
import { FrontendModalService, FrontendModalSize } from '@tablesready/frontend-modal';
import { map, Observable, take } from 'rxjs';

export interface ConfirmationModalRef<T> {
  isConfirmed: T;
  close: (result: T) => void;
  dismiss: (reason?: T) => void;
}

@Injectable({ providedIn: 'root' })
export class ConfirmationModalService {
  constructor(private readonly modalController: FrontendModalService) {}

  confirm(options: ConfirmationModalOptions): Observable<ConfirmationModalRef<boolean>> {
    return this.modalController.create<ConfirmationModalComponent, ConfirmationModalResult<boolean>>(
      ConfirmationModalComponent,
      { options },
      FrontendModalSize.default,
      options.backdropDismiss,
    )
      .pipe(
        take(1),
        map(modalResult => ({
          isConfirmed: modalResult?.response,
          close: (data): void => {
            modalResult.instance.confirm();
          },
          dismiss: (reason): void => {
            modalResult.instance.close();
          },
        })),
      );
  }
}
